import {
  WSField,
  WSFieldProps,
  WSInputContainer,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useModalCategoryPicker } from "./ModalCategoryPicker";
import styles from "./CategoryPicker.module.scss";
import { CategoryPickerValue } from "./types";

type Props = Pick<WSFieldProps, "label" | "status" | "message"> & {
  value?: CategoryPickerValue;
  onChange?: (value: CategoryPickerValue) => void;
  placeholder?: string;
  "data-testid"?: string;
};

export const CategoryPickerField: React.FC<Props> = props => {
  const modalCategoryPicker = useModalCategoryPicker();

  const value = props.value;
  const displayText = value?.wsCategory
    ? value.subcategory
      ? `${value.wsCategory} · ${value.subcategory}`
      : value.wsCategory
    : undefined;

  const openPicker = async () => {
    const result = await modalCategoryPicker.open({ value });
    if (result) {
      props.onChange?.(result);
    }
  };

  return (
    <WSField label={props.label} status={props.status} message={props.message}>
      <WSInputContainer
        onClick={openPicker}
        iconRight="chevron-down"
        status={props.status}
        className={styles.trigger}
      >
        <WSText.ParagraphSm
          color={displayText ? "gray700" : "gray400"}
          data-testid={props["data-testid"]}
        >
          {displayText ?? props.placeholder ?? "Select category"}
        </WSText.ParagraphSm>
      </WSInputContainer>
    </WSField>
  );
};
